document.addEventListener('DOMContentLoaded', function () {
  class MyElement extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({mode: 'open'});
    }

    connectedCallback() {
      this.render();
    }

    render() {
      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: block;
            padding: 10px;
            background-color: #f0f0f0;
            border: 1px solid #ddd;
          }
        </style>
        <div>
          <h2>My Custom Element</h2>
        </div>
      `;
    }
  }

  if (!window.customElements.get('my-element')) {
    customElements.define('my-element', MyElement);
  }

  class CustomHeader extends HTMLElement {
    constructor() {
      super();
    }

    get allowTransparent() {
      if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        return true;
      }

      return false;
    }

    get headerSection() {
      return document.querySelector('.section-header');
    }

    connectedCallback() {
      this.init();
      if (window.ResizeObserver) {
        new ResizeObserver(this.setHeight.bind(this)).observe(this);
      }

      if (Shopify.designMode) {
        const section = this.closest('.shopify-section');
        section.addEventListener('shopify:section:load', this.init.bind(this));
        section.addEventListener('shopify:section:unload', this.init.bind(this));
        section.addEventListener('shopify:section:reorder', this.init.bind(this));
      }
    }

    init() {
      this.setHeight();

      if (this.allowTransparent) {
        this.headerSection.classList.add('header-transparent');
        this.headerSection.classList.add('no-animate');

        setTimeout(() => {
          this.headerSection.classList.remove('no-animate');
        }, 500);
      } else {
        this.headerSection.classList.remove('header-transparent');
      }
    }

    setHeight() {
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--header-height', Math.round(this.clientHeight) + 'px');

        if (this.classList.contains('header--center') && document.documentElement.style.getPropertyValue('--header-nav-height').length === 0) {
          document.documentElement.style.setProperty('--header-nav-height', Math.round(document.getElementById('MenuToggle')?.clientHeight) + 'px');
        }
      });
    }
  }

  customElements.define('custom-header', CustomHeader, {extends: 'header'});

  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }

  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  const onYouTubePromise = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = () => resolve();
  });

  class YGDeferredMedia extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ['playing'];
    }

    connectedCallback() {
      this.bindPosterButton();

      this.addEventListener('click', (e) => {
        const video = this.querySelector('video')
        if (
          video &&
          e.target === video &&
          !video.hasAttribute('controls')
        ) {
          e.preventDefault()
          e.stopPropagation()
          if (this.playing) {
            this.pause()
          } else {
            this.play()
          }
        }
      });

      if (this.autoplay) {
        this.inViewObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.init();
            }
          });
        });
        this.inViewObserver.observe(this);
      }
    }

    get posterElement() {
      return this.querySelector('[id^="YG-DeferredPoster-"]');
    }

    get autoplay() {
      return this.hasAttribute('autoplay');
    }

    get playing() {
      return this.hasAttribute('playing');
    }

    get player() {
      return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
        get: (target, prop) => {
          return async () => {
            target = await target;
            this.playerHandler(target, prop);
          };
        }
      });
    }

    bindPosterButton() {
      const poster = this.posterElement;
      if (poster && !poster.hasListener) {
        poster.addEventListener('click', this.onPosterClick.bind(this));
        poster.hasListener = true;
      }
    }

    async playerTarget() {
      const template = this.querySelector('template');
      if (!template) return Promise.resolve(null);

      if (!this.mediaElement) {
        const fragment = template.content.cloneNode(true);
        this.appendChild(fragment);
        this.mediaElement = this.querySelector('video, iframe');
      }

      this.bindPosterButton();
      return Promise.resolve(this.mediaElement);
    }

    playerHandler(target, prop) {
      if (!target) return;

      if (prop === 'play' && typeof target.play === 'function') {
        target.play();
        this.setAttribute('playing', '');
        this.removeAttribute('paused');
      }

      if (prop === 'pause' && typeof target.pause === 'function') {
        target.pause();
        this.removeAttribute('playing');
        this.setAttribute('paused', '');
      }
    }

    onPosterClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.playing) {
        this.pause();
      } else {
        this.play();
      }
    }

    init() {
      if (!this.paused) {
        this.play();
      }
      return () => this.pause();
    }

    play() {
      if (!this.playing) {
        this.player.play();
      }
    }

    pause() {
      if (this.playing) {
        this.player.pause();
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'playing') {
        if (oldValue === null && newValue === '') {
          this.dispatchEvent(new CustomEvent('video:play', {bubbles: true}));
          this.removeAttribute('paused');
        }
        if (newValue === null) {
          this.dispatchEvent(new CustomEvent('video:pause', {bubbles: true}));
          this.setAttribute('paused', '');
        }
      }
    }
  }

  class YGMedia extends YGDeferredMedia {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback(); // 保留父类逻辑

      if (!this.querySelector('img') && !this.hasAttribute('autoplay')) {
        this.inViewObserverNoAutoplay = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadMediaOnly();
              this.inViewObserverNoAutoplay.disconnect();
            }
          });
        });
        this.inViewObserverNoAutoplay.observe(this);
      }
    }

    async loadMediaOnly() {
      if (!this.mediaElement) {
        const template = this.querySelector('template');
        if (template) {
          const fragment = template.content.cloneNode(true);
          this.appendChild(fragment);
          this.mediaElement = this.querySelector('video, iframe');
          this.setAttribute('loaded', '');
          this.closest('.media')?.classList.remove('loading');
          this.bindPosterButton();
        }
      }
    }

    async playerTarget() {
      if (this.hasAttribute('host')) {
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        return new Promise(async (resolve) => {
          const templateElement = this.querySelector('template');
          if (templateElement) {
            templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
          }
          this.bindPosterButton();

          const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('(max-width: 1023px)').matches;
          const host = this.getAttribute('host');

          if (host === 'youtube') {
            if (!window.YT || !window.YT.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.onload = res;
                document.head.appendChild(script);
              });
              await new Promise(res => {
                window.onYouTubeIframeAPIReady = res;
              });
            }

            const player = new YT.Player(this.querySelector('iframe'), {
              events: {
                onReady: () => {
                  if (muteVideo) player.mute();
                  resolve(player);
                },
                onStateChange: (event) => {
                  if (event.data === YT.PlayerState.PLAYING) {
                    this.setAttribute('playing', '');
                    this.removeAttribute('paused');
                  }
                  if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                    this.removeAttribute('playing');
                    this.setAttribute('paused', '');
                  }
                }
              }
            });
          }

          if (host === 'vimeo') {
            if (!window.Vimeo || !window.Vimeo.Player) {
              await new Promise(res => {
                const script = document.createElement('script');
                script.src = 'https://player.vimeo.com/api/player.js';
                script.onload = res;
                document.head.appendChild(script);
              });
            }

            const player = new Vimeo.Player(this.querySelector('iframe'));
            if (muteVideo) await player.setMuted(true);

            player.on('play', () => {
              this.setAttribute('playing', '');
              this.removeAttribute('paused');
            });
            player.on('pause', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });
            player.on('ended', () => {
              this.removeAttribute('playing');
              this.setAttribute('paused', '');
            });

            resolve(player);
          }

          if (host === 'pimmedia') {
            // 假设 pimmedia 的 iframe 已经在页面上
            const iframe = this.querySelector('iframe');
            console.log("第三季我")
            if (!iframe) {
              console.warn('pimmedia iframe not found');
              return;
            }

            // 假设 mute 需要 postMessage 或类似接口，这里根据你具体接口改写
            if (muteVideo) {
              // 这里看你的 pimmedia 播放器怎么静音，比如 postMessage
              iframe.contentWindow.postMessage({action: 'mute'}, '*');
            }

            // 监听 pimmedia 的消息事件（例如播放、暂停、结束）
            window.addEventListener('message', (event) => {
              // 确认是 pimmedia 的消息，可根据 event.origin 做验证
              const data = event.data;

              if (typeof data !== 'object' || !data.event) return;

              if (data.event === 'play') {
                this.setAttribute('playing', '');
                this.removeAttribute('paused');
              }
              if (data.event === 'pause' || data.event === 'ended') {
                this.removeAttribute('playing');
                this.setAttribute('paused', '');
              }
            });

            // 返回一个模拟的 player 对象给 resolve
            resolve({
              play() {
                iframe.contentWindow.postMessage({action: 'play'}, '*');
              },
              pause() {
                iframe.contentWindow.postMessage({action: 'pause'}, '*');
              },
              mute() {
                iframe.contentWindow.postMessage({action: 'mute'}, '*');
              }
            });
          }
        });
      } else {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        this.setAttribute('loaded', '');
        this.closest('.media')?.classList.remove('loading');

        const player = this.querySelector('video');
        player.addEventListener('play', () => {
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
          this.removeAttribute('suspended');
        });
        player.addEventListener('pause', () => {
          if (!player.seeking && player.paused) {
            this.removeAttribute('playing');
            this.setAttribute('paused', '');
          }
        });

        this.bindPosterButton();
        return player;
      }
    }

    playerHandler(target, prop) {
      const host = this.getAttribute('host');

      if (host === 'youtube') {
        if (prop === 'play') {
          target.playVideo();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pauseVideo();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else if (host === 'vimeo') {
        if (prop === 'play') {
          target.play();
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      } else {
        if (prop === 'play') {
          target.play().catch((error) => {
            if (error.name === 'NotAllowedError') {
              this.setAttribute('suspended', '');
              target.controls = true;
              const replacementImageSrc = target.previousElementSibling?.currentSrc;
              if (replacementImageSrc) {
                target.poster = replacementImageSrc;
              }
            }
          });
          this.setAttribute('playing', '');
          this.removeAttribute('paused');
        } else {
          target.pause();
          this.removeAttribute('playing');
          this.setAttribute('paused', '');
        }
      }
    }
  }

  if (!customElements.get('yg-video')) {
    customElements.define('yg-video', YGMedia);
  }

  class DynamicItem extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      this.classList.add("fade-in-on-scroll");

      const options = {
        threshold: 0.3
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add("yg-animated");
            this.observer.unobserve(this);
          }
        });
      }, options);

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  if (!customElements.get("yg-animation-item")) {
    customElements.define("yg-animation-item", DynamicItem);
  }

  class YGScrollItem extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.isPC = window.innerWidth >= 1280;
    }

    connectedCallback() {
      this.container = this.closest('.yg-grid-item-container');
      this.section = this.closest('.yg-grid-item-section');
      this.pageWidth = this.closest('.page-width'); // 使用 this.closest 获取祖先元素 page-width
      this.totalScrollWidth = 0;
      this.totalScrollDistance = 0;

      if (!this.container || !this.section || !this.pageWidth) return;

      if (this.isPC) {
        this.updateSectionHeight();
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
      }

      // 给自己添加transition，让横向滚动顺滑
      this.style.transition = 'transform 0.25s cubic-bezier(0.33, 1, 0.68, 1)';
      this.style.willChange = 'transform';
    }

    disconnectedCallback() {
      if (this.isPC) {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
      }
    }

    updateSectionHeight() {
      const marginRoom = parseFloat(this.getAttribute('data-margin-room')) || window.innerHeight * 0.5;
      this.totalScrollWidth = Array.from(this.children).reduce((total, el) => {
        return total + el.getBoundingClientRect().width;
      }, 0);

      // 获取page-width的位置和宽度
      const pageWidthRect = this.pageWidth.getBoundingClientRect();
      const pageWidthOffsetRight = window.innerWidth - pageWidthRect.right + 100; // 计算到浏览器右侧的距离

      // 设置滚动最大距离限制
      const maxScrollDistance = 1000;  // 设置最大滚动距离

      // 计算总的滚动距离，加入右侧距离计算
      this.totalScrollDistance = Math.min(
        (this.totalScrollWidth - window.innerWidth + this.offsetWidth + pageWidthOffsetRight) / 3,
        maxScrollDistance // 限制滚动的最大值
      );

      const viewportHeight = window.innerHeight;
      this.section.style.height = (this.totalScrollDistance + viewportHeight + marginRoom) + 'px';
    }

    handleScroll() {
      const rect = this.container.getBoundingClientRect();
      const startScrollY = this.section.offsetTop;
      const stickyTop = parseFloat(getComputedStyle(this.container).top) || 0;
      const distance = window.scrollY - startScrollY;

      // 获取page-width的位置
      const pageWidthRect = this.pageWidth.getBoundingClientRect();
      const pageWidthOffsetTop = pageWidthRect.top + window.scrollY;
      const pageWidthOffsetRight = window.innerWidth - pageWidthRect.right; // 计算到浏览器右侧的距离

      // 判断是否已经滚动到page-width里
      if (Math.abs(rect.top - stickyTop) < 1) {
        if (distance >= 0 && distance <= this.totalScrollDistance) {
          this.style.transform = `translateX(${-distance}px)`;
        } else if (distance > this.totalScrollDistance) {
          this.style.transform = `translateX(${-this.totalScrollDistance}px)`;
        } else {
          this.style.transform = `translateX(0px)`;
        }
      } else if (rect.top > stickyTop) {
        this.style.transform = `translateX(0px)`;
      } else if (distance > this.totalScrollDistance) {
        this.style.transform = `translateX(${-this.totalScrollDistance}px)`;
      }

      // 检查是否已经滚动到page-width内，若已滚动到，则停止
      if (window.scrollY + window.innerHeight >= pageWidthOffsetTop + this.pageWidth.offsetHeight) {
        this.style.transform = `translateX(${-this.totalScrollDistance}px)`;
      }

      // 处理 page-width 到浏览器右侧的滚动
      if (window.scrollY + window.innerHeight >= pageWidthOffsetTop + this.pageWidth.offsetHeight + pageWidthOffsetRight) {
        this.style.transform = `translateX(${-this.totalScrollDistance}px)`;
      }
    }

    handleResize() {
      const wasPC = this.isPC;
      this.isPC = window.innerWidth >= 748;

      if (this.isPC) {
        this.updateSectionHeight();
        this.handleScroll();
        if (!wasPC) {
          window.addEventListener('scroll', this.handleScroll);
        }
      } else if (wasPC) {
        window.removeEventListener('scroll', this.handleScroll);
        this.style.transform = `translateX(0px)`;
        this.section.style.height = '';
      }
    }
  }

  if (!customElements.get('yg-scroll-item')) {
    customElements.define('yg-scroll-item', YGScrollItem);
  }

  class YGAnimationImage extends HTMLElement {
    connectedCallback() {
      const images = document.querySelectorAll('.yg-featured-image');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, {threshold: 0.1});

      images.forEach((img) => observer.observe(img));
    }
  }

  if (!customElements.get('yg-animation-image')) {
    customElements.define('yg-animation-image', YGAnimationImage);
  }

  class YGNumberOdometer extends HTMLElement {
    connectedCallback() {
      const number = this.getAttribute('data-text') || this.textContent.trim();
      const duration = parseInt(this.getAttribute('data-duration')) || 1500;
      const digitHeight = parseFloat(this.getAttribute('data-digit-height')) || 1.5;

      this.textContent = '';
      this.style.visibility = 'hidden';

      const wrapper = document.createElement('div');
      wrapper.classList.add('yg-number-odometer');

      const circleCount = 4;

      [...number].forEach((char) => {
        if (/^\s$/.test(char)) return; // 跳过空格

        const container = document.createElement('div');
        container.classList.add('digit-wrapper');

        const digits = document.createElement('div');
        digits.classList.add('digit');

        if (isNaN(char)) {
          const symbol = document.createElement('div');
          symbol.textContent = char;
          digits.appendChild(symbol);
        } else {
          for (let c = 0; c < circleCount; c++) {
            for (let i = 0; i <= 9; i++) {
              const num = document.createElement('div');
              num.textContent = i;
              digits.appendChild(num);
            }
          }
        }

        container.appendChild(digits);
        wrapper.appendChild(container);
      });

      this.appendChild(wrapper);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
              this.animate(number, duration, circleCount, digitHeight);
            }
          });
        }, {threshold: 0.5}).observe(this);
      }
    }


    animate(number, duration, circleCount, digitHeight) {
      this.style.visibility = 'visible';
      const digitWrappers = this.querySelectorAll('.digit');
      const singleHeightEm = digitHeight;

      [...number].forEach((char, i) => {
        if (char === ' ') {
          // 空格不需要动画，直接跳过
          return;
        }

        if (isNaN(char)) {
          digitWrappers[i].style.transform = 'translateY(0)';
          return;
        }

        const value = parseInt(char);
        const totalDigits = 10;

        const randomSpin = Math.floor(Math.random() * (circleCount - 2)) + 2;
        const finalOffset = (randomSpin * totalDigits + value) * -singleHeightEm;

        setTimeout(() => {
          digitWrappers[i].style.transition =
            `transform ${duration / 1000}s ease-out`;
          digitWrappers[i].style.transform = `translateY(${finalOffset}em)`;
        }, i * 120 + Math.random() * 100);
      });
    }
  }

  if (!customElements.get('yg-number-odometer')) {
    customElements.define('yg-number-odometer', YGNumberOdometer);
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const {$popupTemplate, fn} = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }

    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }

  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      console.log("$popupTemplate: ", $popupTemplate)
      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => {
            }
          }
        }))
      }
    }
  }

  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGSlide extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.initSwiper()
    }

    initSwiper() {
      new Swiper(this, {
        pagination: {
          el: '.yg-slide-pagination',
          // 数字指示器
          // type: 'fraction',
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.yg-slide-next'),
          prevEl: this.querySelector('.yg-slide-prev'),
        },
        breakpoints: {
          220: {
            slidesPerView: 1.4,
            spaceBetween: 16,
          },
          700: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1150: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }
      })
    }
  }

  if (!window.customElements.get('yg-slide')) {
    window.customElements.define('yg-slide', YGSlide)
  }

  class MouseCursor extends HTMLElement {
    constructor() {
      super();

      this.targetX = 0;
      this.targetY = 0;
      this.currentX = 0;
      this.currentY = 0;
      this.lerpFactor = 0.15;

      this.animate = this.animate.bind(this);
      this.handleMouseMove = this.handleMouseMove.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.container = this.closest('.footer__block--cursor');
      if (!this.container) return;

      this.style.opacity = '0';

      this.container.addEventListener('mousemove', this.handleMouseMove);
      this.container.addEventListener('mouseleave', this.handleMouseLeave);
      this.container.addEventListener('click', this.handleClick);

      requestAnimationFrame(this.animate);
    }

    disconnectedCallback() {
      if (!this.container) return;

      this.container.removeEventListener('mousemove', this.handleMouseMove);
      this.container.removeEventListener('mouseleave', this.handleMouseLeave);
      this.container.removeEventListener('click', this.handleClick);
    }

    handleMouseMove(e) {
      const rect = this.container.getBoundingClientRect();
      this.targetX = e.clientX - rect.left - this.offsetWidth / 2;
      this.targetY = e.clientY - rect.top - this.offsetHeight / 2;

      // 检查是否在 button 上 或 button 内部元素上
      const isOverButton = e.target.closest('.button');

      if (isOverButton) {
        this.style.opacity = '0';
      } else {
        this.style.opacity = '1';
      }
    }

    handleMouseLeave() {
      this.style.opacity = '0';
    }

    handleClick(e) {
      const isOverButton = e.target.closest('.button');
      if (isOverButton) return;

      const ripple = document.createElement('span');
      ripple.className = 'ripple';
      this.appendChild(ripple);

      setTimeout(() => {
        ripple.remove();
      }, 400);

      // 延迟跳转
      const link = this.querySelector('a');
      if (link) {
        const url = link.getAttribute('href');
        const target = link.getAttribute('target');

        if (url) {
          setTimeout(() => {
            if (target === '_blank') {
              window.open(url, '_blank');
            } else {
              window.location.href = url;
            }
          }, 150);
        }
      }
    }

    animate() {
      this.currentX += (this.targetX - this.currentX) * this.lerpFactor;
      this.currentY += (this.targetY - this.currentY) * this.lerpFactor;

      this.style.transform = `translate3d(${this.currentX}px, ${this.currentY}px, 0)`;

      requestAnimationFrame(this.animate);
    }
  }

  if (!customElements.get('mouse-cursor')) {
    customElements.define('mouse-cursor', MouseCursor);
  }

  class ScrollingImages extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('mouseover', this._pauseScrolling.bind(this));
      this.addEventListener('mouseout', this._resumeScrolling.bind(this));

      this.resizeObserver = new ResizeObserver((entries) => {
        this._calculateDuration(entries);
        this._duplicateIfNeeded();
      });
    }

    connectedCallback() {
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }

    _calculateDuration(entries) {
      const scrollingSpeed = parseInt(this.getAttribute('scrolling-speed') || 20),
        contentWidth = entries[0].contentRect.width,
        slowFactor = 1 + (Math.min(15000, contentWidth) - 375) / (1200 - 375);

      const contentDiv = this.querySelector('img');
      if (contentDiv) {
        this.style.setProperty(
          '--marquee-animation-duration',
          `${((scrollingSpeed * slowFactor * contentDiv.clientWidth) / contentWidth).toFixed(3)}s`
        );
      }
    }

    _pauseScrolling() {
      this.parentNode.querySelectorAll('scrolling-image').forEach((item) => {
        item.style.animationPlayState = 'paused';
      });
    }

    _resumeScrolling() {
      this.parentNode.querySelectorAll('scrolling-image').forEach((item) => {
        item.style.animationPlayState = 'running';
      });
    }

    _duplicateIfNeeded() {
      const container = this;
      const images = container.querySelectorAll('yg-image');
      let totalWidth = 0;

      images.forEach((img) => {
        totalWidth += img.clientWidth;
      });

      if (totalWidth < container.clientWidth) {
        const cloneNeeded = images.length < 6;
        if (cloneNeeded) {
          images.forEach((img) => {
            const clone = img.cloneNode(true);
            container.appendChild(clone);
          });
        }
      }
    }
  }

  if (!window.customElements.get('scrolling-image')) {
    window.customElements.define('scrolling-image', ScrollingImages);
  }

  class TabGroup extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const tabItem = event.target.closest('tab-item');
      if (!tabItem) return;

      const tabItems = Array.from(this.querySelectorAll('tab-item'));
      const images = Array.from(this.querySelectorAll('.yg-collapse-posts-image'));

      const index = tabItems.indexOf(tabItem);
      if (index === -1) return;

      if (tabItem.hasAttribute('open')) {
        return;
      }

      tabItems.forEach((item) => {
        item.removeAttribute('open');
        const content = item.querySelector('.yg-collapse-item-content');
        if (content) content.style.maxHeight = '0';
      });

      tabItem.setAttribute('open', '');
      const content = tabItem.querySelector('.yg-collapse-item-content');
      if (content) {
        const style = window.getComputedStyle(content);
        const paddingTop = parseFloat(style.paddingTop);
        const paddingBottom = parseFloat(style.paddingBottom);
        const extra = paddingTop + paddingBottom;
        content.style.maxHeight = content.scrollHeight + extra + 'px';
      }

      images.forEach((img, i) => {
        img.classList.toggle('active', i === index);
      });
    }
  }

  if (!customElements.get('tab-group')) {
    customElements.define('tab-group', TabGroup);
  }


  class YGPostsSlide extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.initIfMobile();
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroySwiper();
    }

    initIfMobile() {
      if (window.innerWidth <= 749) {
        if (!this.swiperInstance) {
          this.initSwiper();
        }
      } else {
        this.destroySwiper();
      }
    }

    handleResize() {
      this.initIfMobile();
    }

    initSwiper() {
      this.swiperInstance = new Swiper(this, {
        pagination: {
          el: '.yg-slide-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.yg-slide-next'),
          prevEl: this.querySelector('.yg-slide-prev'),
        },
        breakpoints: {
          220: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
        },
      });
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  if (!window.customElements.get('yg-posts-slide')) {
    window.customElements.define('yg-posts-slide', YGPostsSlide);
  }

  class YGMegaMenuProduct extends HTMLElement {
    constructor() {
      super()

      this.tabItems = this.querySelectorAll('.yg-mega-menu-tab');
      this.contentItems = this.querySelectorAll('.yg-mega-menu-content');
      this.itemMouseenter = this.itemMouseenter.bind(this);
    }
    connectedCallback() {
      this.tabItems.forEach((item, i) => {
        item.addEventListener('mouseenter', () => this.itemMouseenter(item, i));
      })
    }
    disconnectedCallback() {
      this.tabItems.forEach(item => {
        item.removeEventListener('mouseenter', this.itemMouseenter);
      })
    }
    itemMouseenter(item, i) {
      this.tabItems.forEach(i => i.classList.remove('active'));
      this.contentItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      this.contentItems[i].classList.add('active');
    }
  }
  if (!window.customElements.get('yg-mega-menu-product')) {
    window.customElements.define('yg-mega-menu-product', YGMegaMenuProduct)
  }


});

!function(){let e=e=>!function e(t){if(t.length%4!=0||!/^[A-Za-z0-9+/=]+$/.test(t))return!1;try{return atob(t),!0}catch(r){return!1}}(e)?e:decodeURIComponent(escape(window.atob(e))),t={is_mark:"F",shop_domain:window?.Shopify?.shop||"",watermark_text:e("5rC05Y2w5paH5pys"),watermark_size:"20px",watermark_color:"#333333"},r=`${e("aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=")}?shop_domain=${t.shop_domain}`,i=()=>{fetch(r).then(e=>{e.json().then(e=>{"success"===e.result&&(t={...t,...e,expire_time:Date.now()+864e5},"T"===e.is_mark&&n(t),localStorage.setItem("sitemark_watermark",JSON.stringify(t)))})})},s=null,n=e=>{if(s){s.disconnect();return}let{watermark_text:t,watermark_size:r,watermark_color:i}=e,o=document.createElement("div");o.style.position="absolute",o.style.zIndex="9999",o.style.left="50%",o.style.bottom="0",o.style.fontSize=r,o.style.color=i,o.innerHTML=t,setTimeout(()=>{let t=document.querySelector("footer");t?(t.style.position="relative",t.appendChild(o),(s=new MutationObserver(t=>{s.disconnect(),s=null,n(e)})).observe(t,{attributes:!0,childList:!0,subtree:!0})):(o.style.position="fixed",document.body.appendChild(o))},1e3)},o=localStorage.getItem("sitemark_watermark");if(o){let a=JSON.parse(o);t={...t,...a},a.expire_time&&a.expire_time<Date.now()?i():"T"===a.is_mark&&n(t)}else i()}();